import React, { lazy, Suspense } from 'react';

const SitemapPage = lazy(() => import('./sitemapPage'));

export const SitemapPageLazy = () => {
    return (
        <Suspense fallback={<div>Loading...</div>}>
            <SitemapPage />
        </Suspense>
    );
};